import {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {payAPI} from "../../../services/client";

//결제 인증 성공 페이지
export const ClientPaymentSuccessPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(true);

    useEffect(() => {
        const processPayment = async () => {
            try {
                //인증 성공 시 반환받는 값, 결제 API에 필요
                const paymentKey = searchParams.get('paymentKey');
                const orderId = searchParams.get('orderId');
                const amount = searchParams.get('amount');

                if (!paymentKey || !orderId || !amount) {
                    throw new Error('필수 결제 정보가 누락되었습니다.');
                }
                //백엔드 결제 API 호출
                await payAPI({
                    paymentKey,
                    orderId,
                    amount: parseInt(amount)
                });
                //결제 페이지로 이동
                navigate('/client/billing', {replace: true});
                // navigate 후에 리로드
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                console.error('결제 처리 중 오류 발생:', error);
                navigate('/payment/fail', {
                    replace: true,
                    state: {error: '결제 처리 중 오류가 발생했습니다.'}
                });
            } finally {
                setIsProcessing(false);
            }
        };

        processPayment();
    }, [navigate, searchParams]);

    if (isProcessing) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <h2 className="text-xl font-semibold mb-2">결제 처리 중...</h2>
                    <p className="text-gray-600">잠시만 기다려주세요.</p>
                </div>
            </div>
        );
    }

    return null;
};

export default ClientPaymentSuccessPage;